module.exports = __webpack_public_path__ + "img/stefan.6149802c.jpg";